import { alpha } from '@mui/material';

export const getInternationalSectionStyles = (theme, isDark) => ({
  wrapper: {
    width: '100%',
  },
  titleText: {
    fontWeight: 700,
    fontSize: { xs: '1rem', sm: '1.1rem' },
    mb: 0.5,
    color: 'text.primary',
  },
  emptyState: {
    py: 3,
    px: 2,
    borderRadius: 2,
    border: `1px solid ${theme.palette.divider}`,
    textAlign: 'center',
    bgcolor: isDark
      ? alpha(theme.palette.common.white, 0.02)
      : alpha(theme.palette.common.black, 0.02),
  },
  emptyText: {
    color: 'text.secondary',
    fontSize: '0.85rem',
  },
  scrollContainer: {},
});
